<script lang="ts" setup>
import type { Proximity } from "@/api/employeeMovements";
import { useTimelines } from "@/composables/timelines";
import { useScreenType } from "@/composables/useScreenType";
import { ElTooltip } from "element-plus";

export interface Props {
  source?: string;
  proximity?: Proximity;
  hidden?: boolean;
}

const props = defineProps<Props>();

const { methodIcon, methodLabel } = useTimelines();
const { isMobile } = useScreenType();
</script>

<template>
  <el-tooltip
    effect="dark"
    :content="methodLabel(props.source)"
    placement="left"
    :disabled="isMobile"
  >
    <font-awesome-icon
      :icon="['fal', methodIcon(props.source, props.proximity)]"
      size="xl"
      :class="['method-icon', { hidden }]"
    />
  </el-tooltip>
</template>

<style lang="scss" scoped>
.method-icon {
  color: var(--so-tag-hover-color-custom);
  width: 24px;

  &.hidden {
    visibility: hidden;
  }
}
</style>
